
import localforage from "localforage";

// vuex plugin
export default function(store){
  var domain = location.hostname.split(".");
  var name = "the-reading";
  if(domain[0].endsWith("t-3mt")
    || domain[0].startsWith("localhost")){
    name = "t-3mt";
  }
  localforage.config({
    name: name,
    storeName: "editor"
  });
  const backup_items = {
    // "setEnableBackup": 一時情報
    "setLayoutMode": [
      "layout_mode"
    ],
    "setMenuMode": [
      "menu_mode"
    ],
    "setSentenceMode": [
      "sentence_mode"
    ],
    "setMemoMode": [
      "memo_mode"
    ],
    "setTabs": [
      "tabs"
    ],
    // "setSelectTab": 一時情報
    // "setBackupSideMenu": 一時情報
    "setFontSize": [
      "font_size"
    ],
    "setSearchTarget": [
      "search_target"
    ],
    "setSearchString": [
      "search_string"
    ],
    "setReplaceString": [
      "replace_string"
    ],
    "setSearchFiltering": [
      "search_filtering"
    ],
    "setSearchCaseSensitive": [
      "search_case_sensitive"
    ],
    // "editor/setSearchField": 一時情報
    "setFilterMemoExists": [
      "filter_memo_exists"
    ],
    // "editor/setHistoryLimit": 起動時に復元
    // "editor/setShortcut": 起動時に復元
    // "editor/setSelectText": 一時情報
  };
  const backup_content_items = {
    // "editor/*/setEditorContent": 復元用
    // "editor/*/setInternalSelectIndexes": 一時情報
    // "editor/*/setSelectColumn": 一時情報
    // "editor/*/setSelectTerm": 一時情報
    "setContentMode": [
      "content_mode"
    ],
    "setContentId": [
      "content_id"
    ],
    "setContentName": [
      "content_name"
    ],
    "setContent": [
      "content"
    ],
    "setContentOriginal": [
      "content_original"
    ],
    "setContentModified": [
      "content_modified"
    ],
    "updateSentence": [
      "content",
      "content_modified"
    ],
    "updateStatus": [
      "content",
      "content_modified"
    ],
    // "editor/setSaving": 一時情報
    "setFilterStatus": [
      "filter_status"
    ],
    "setFilterMemoExists": [
      "filter_memo_exists"
    ],
    "setHistoryInternal": [
      "history"
    ],
    "setHistoryIndex": [
      "history_index",
    ],
  };
  store.subscribe((mutation, state) => {
    // エディタ関係
    if(!(state.preference)
      || !(state.preference.editor)
      || !("enable_backup" in state.preference.editor)
      || state.preference.editor.enable_backup){
      // デフォルトはバックアップあり。明確にバックアップを無効にしない限りは保存する
      var xid = null;
      var key = mutation.type.replace("editor/", "");
      if(key.indexOf("/") >= 0){
        [xid, key] = key.split("/");
      }
      if((key === "setTabs" && mutation.payload.length > 0)
        || key === "setContentStart"
        || (state.editor.tabs.length > 0 && (key in backup_items))
        || (state.editor[xid + "/content"] !== null && (key in backup_content_items))){
        localforage.ready()
        .then(() => {
          if(key === "setTabs"
            && mutation.payload.length > 0){
            localforage.setItem(
              "user",
              state.user
            );
            // .catchは一段上の方へ飛んでいく
            var backup_keys = state.editor.backup_keys;
            for(var backup_key of backup_keys){
              localforage.setItem(
                backup_key,
                state.editor[backup_key]
              );
              // .catchは一段上の方へ飛んでいく
            }
          }else if(state.editor.tabs.length > 0
            && xid === null
            && (key in backup_items)){
            for(var backup_item of backup_items[key]){
              if(backup_item in state.editor){
                localforage.setItem(
                  backup_item,
                  state.editor[backup_item]
                );
                // .catchは一段上の方へ飛んでいく
              }
            }
          }else if(key === "setContentStart"){
            var backup_keys = state.editor.backup_content_keys;
            for(var backup_key of backup_keys){
              localforage.setItem(
                xid + "_" + backup_key,
                state.editor[xid][backup_key]
              );
              // .catchは一段上の方へ飛んでいく
            }
          }else if(state.editor[xid + "/content"] !== null
            && (key in backup_content_items)){
            for(var backup_item of backup_content_items[key]){
              if(xid in state.editor
                && backup_item in state.editor[xid]){
                localforage.setItem(
                  xid + "_" + backup_item,
                  state.editor[xid][backup_item]
                );
                // .catchは一段上の方へ飛んでいく
              }
            }
          }
          localforage.setItem(
            "utime",
            Math.floor(new Date() / 1000)
          );
          // .catchは一段上の方へ飛んでいく
        })
        .catch(function(e){
          if(state.debug){
            console.error("localforage.ready/setItem:" + e);
          }
          store.commit("setNotification", {
            type: "warning",
            message: {
              eid: "E191113:00000005",
              param: {}
            }
          });
        });
      }
    }
  });
}
